import { render } from "./StatsPanel.vue?vue&type=template&id=624bc008&ts=true"
import script from "./StatsPanel.vue?vue&type=script&lang=ts"
export * from "./StatsPanel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__